export function isValidSfccRelativePath(value: string): boolean {
  const trimmed = value.trim();
  if (
    !trimmed ||
    trimmed !== value ||
    trimmed.startsWith('//') ||
    trimmed.startsWith('\\') ||
    /^[A-Za-z][A-Za-z\d+.-]*:/u.test(trimmed)
  ) {
    return false;
  }

  try {
    return new URL(trimmed, 'https://sfcc-path.invalid').origin === 'https://sfcc-path.invalid';
  } catch {
    return false;
  }
}
